// extracted by mini-css-extract-plugin
export var content = "_1-1";
export var shell = "_1-0";